import { RICH_TEXT_CONTENT_CLASS } from "@jugl-web/domain-resources/common/components/RichTextarea";
import { InteractiveContainer, Radio } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import React, { useEffect, useState } from "react";
import { useWhatsappTemplateBodyRenderer } from "../../../../../ManageAccountsDrawer/screens/WhatsappAccountScreen/components/WhatsappLogsHistoryTab/components/AccountLogDetailsDialog/hooks/useWhatsappTemplateBodyRenderer";
import { ReactComponent as WhatsappIcon } from "./assets/whatsapp.svg";

export interface TemplateListItemProps {
  name: string;
  body: string;
  isSelected: boolean;
  onSelect: () => void;
}

export const TemplateListItem: React.FC<TemplateListItemProps> = ({
  name,
  body,
  isSelected,
  onSelect,
}) => {
  const { renderHtml } = useWhatsappTemplateBodyRenderer();
  const [html, setHtml] = useState("");

  useEffect(() => {
    let isActive = true;
    renderHtml({ body, variables: [] }).then((next) => {
      if (isActive) setHtml(next);
    });
    return () => {
      isActive = false;
    };
  }, [body, renderHtml]);

  return (
    <InteractiveContainer
      className={cx(
        "flex w-full items-start gap-2.5 rounded-lg bg-white px-2 py-3 transition-colors hover:bg-grey-100",
        isSelected && "bg-grey-100"
      )}
      onClick={onSelect}
    >
      <div className="flex grow flex-col gap-1 overflow-hidden">
        <div className="flex items-center gap-2">
          <WhatsappIcon />
          <span className="truncate font-secondary text-sm leading-5.25 font-medium text-dark">
            {name}
          </span>
        </div>
        <div
          className={cx(
            "line-clamp-2 font-secondary text-sm leading-5.25 text-dark-600",
            RICH_TEXT_CONTENT_CLASS
          )}
          // oxlint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
      <Radio isChecked={isSelected} readOnly />
    </InteractiveContainer>
  );
};
